export interface LovUsageCounts {
    orgLibraryCount: number;
    studyRecordCount: number;
    studyCount: number;
}

export const countStudyRecordsAndStudies = <T extends { studyId?: string | null }>(
    matchingRecords: T[],
): { studyRecordCount: number; studyCount: number } => {
    const uniqueStudyIds = new Set(matchingRecords.map((r) => r.studyId).filter((id): id is string => !!id));
    return { studyRecordCount: matchingRecords.length, studyCount: uniqueStudyIds.size };
};
